import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractCancellation.Save.IRequest;
type Response = Api.Core.ContractCancellation.Save.IResponse;
type Headers = Api.Core.ContractCancellation.Save.IHeaders;
const url = '/api/Sales/ContractCancellation';
export default async function contractCancellationSaveApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
